/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type ApplicationScope = typeof ApplicationScope[keyof typeof ApplicationScope];


export const ApplicationScope = {
  STAGE: 'STAGE',
  BACKSTAGE: 'BACKSTAGE',
} as const;
